import React from "react";
import { C, F } from "@tokens";

/**
 * LoadingState — estado de carregamento padrão. Usa um spinner
 * circular animado com a cor brand da Unimed.
 *
 * @param {string} [message] - texto exibido abaixo do spinner
 */
export default function LoadingState({ message = "Carregando…" }) {
  return (
    <div
      style={{
        padding: "48px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        background: C.surface,
        borderRadius: 16,
        border: `1px solid ${C.border}`,
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: `3px solid ${C.border}`,
          borderTopColor: C.g700,
          animation: "dash121spin 1s linear infinite",
        }}
      />
      <div style={{ fontSize: 12, color: C.text3, fontFamily: F.text }}>
        {message}
      </div>
      <style>{`@keyframes dash121spin{to{transform:rotate(360deg);}}`}</style>
    </div>
  );
}
